import { AccountState } from '@api/store/account/types';
import { WithTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { BrowserInterface } from '@api/store';
import { StatisticsChannelsState } from '@api/store/channels/types';
import { EmailsState } from '@api/store/emails/types';
import { LogsState, LogTypesString } from '@api/store/logs/types';
import { StatisticsState } from '@api/store/statistics/types';
import { CampaignsState } from '@api/store/campaigns/types';
import { RecipientEvent, Recipient } from '@dev/ee-api/ee-api-models';
import { CustomTableRowsProps, CustomTableHeadersProps } from '@dev/ee-components';
import { ConfigState } from '@api/store/config/types';

export enum LogTypesNumber {
    email = 0,
    notification = 1,
    sms = 2,
}
interface MatchParams {
    logType?: LogTypesString;
    msgID?: string;
}

export interface LogsInterface extends WithTranslation, RouteComponentProps<MatchParams> {
    logs: LogsState;
    browser: BrowserInterface;
    account: AccountState;
    channels?: StatisticsChannelsState;
    emails?: EmailsState;
    statistics?: StatisticsState;
    campaigns?: CampaignsState;
    config?: ConfigState;
}

export interface UseLogsTableDataRowsInterface {
    onRowIconClick?(msgId: string): void;
    onRowEmailClick?(email: string): void;
    onBounceDetailsClick?(title: string, description: string, recipientEvent: RecipientEvent | Recipient): void;
}
export interface UseLogsTableDataHeadersInterface {
    onHeadersEventFilterClick?(ev?: React.ChangeEvent<HTMLInputElement>, selected?: (string | number)[]): void;
    selectedEventsCheckboxes?: string[];
    fetchCountsForEvents?(): void;
    eventFiltersType?: EventsFiltersTypeEnum;
}
export enum EventsFiltersTypeEnum {
    InProgress,
    All,
}
export interface LogsTableInterface extends UseLogsTableDataRowsInterface, UseLogsTableDataHeadersInterface {
    rows?: CustomTableRowsProps[];
    headers?: CustomTableHeadersProps[];
    fetchNextOnScroll(): void;
    eventFiltersType?: EventsFiltersTypeEnum;
}
